import { FaLock } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";

export default function PrivateEmpty() {
    const navigate = useNavigate();

    return (
        <>
            {/* Header */}
            <div className="sticky top-0 z-10">
                <div className="relative bg-[#BDE6FF] rounded-b-xl h-12 flex items-center justify-center">
                    <IoMdArrowBack
                        onClick={() => navigate("/account/settings")}
                        className="absolute left-2 top-1/2 transform -translate-y-1/2 text-[22px] text-black dark:text-black cursor-pointer"
                    />
                    <p className="font-bold text-[18px] text-black dark:text-black">Private</p>
                </div>
            </div>

            <div className="flex flex-col gap-10 pt-10 items-center bg-white dark:bg-[#1E1D21] h-full">
                <p className="text-center px-5 dark:text-[white] text-black text-[12px] font-bold uppercase">
                    Create your unique password to access your private page
                </p>
                <button
                    onClick={() => navigate("/private/createpassword")}
                    className="bg-[#BDE6FF] flex gap-2 px-3 py-2 rounded-md items-center text-black font-[600] text-[14px] hover:bg-[#9CDFFF] transition-all"
                >
                    <FaLock className="text-[1rem]" /> Create Password
                </button>
            </div>
        </>
    );
}
